import { filter, merge } from 'lodash';
import moment from "moment";
import { isIfTiff, isIfLcp } from './txnUitls'

export const sortDataByDate = (data) => {
    let startDate = data.startDate ? moment.tz(moment(data.startDate).format('MM/DD/YYYY'), 'America/New_York').format('x') : null
    let endDate = data.endDate ? moment.tz(moment(data.endDate).format('MM/DD/YYYY'), 'America/New_York').format('x') : null
    let sortedTransactionalDetails = {
        'contributions': [],
        'exchanges': [],
        'grants': [],
        'otherTransactions': [],
        'allTransactionData': [],
        'sortedBalanceDetails': []
    }
    const todayDate = () => {
        var todayDate = moment();
        var today = todayDate.format("L");
        return today;
    };
    let isCustomDates = false;
    if (data.selectedVal.length > 0) {
        if (data.selectedVal[0].toString().match('Custom Dates')) {
            isCustomDates = true;
        }
    }
    const filterData = (data, tType, fType, sDate, eDate) => {
        let oldData = sortedTransactionalDetails[tType]
        let dataArray = filter(data, function (o) {
            return (eDate >= o[fType] && o[fType] >= sDate);
        });
        return oldData.concat(dataArray);
    }

    const addExchangeAmount = (data) => {
        let amount = 0;
        if (data && data.length > 0) {
            data.forEach((row) => {
                amount += parseFloat(row.value);
            })
        } else {
            amount = data;
        }
        return amount;
    }

    const getAllTransactionData = (data) => {
        let allTransactionData = [];
        data.contributions.map((data) => {
            let newData = { ...data, ...{ tabType: 'Contribution' } };
            allTransactionData.push(newData);
        })
        data.grants.map((data) => {
            let newData = { ...data, ...{ tabType: 'Grant' } };
            allTransactionData.push(newData);
        })
        data.exchanges.map((data) => {
            let fromExchangesData = {};
            let toExchangesData = {};
            if (data.fromInvestmentOption) {
                fromExchangesData = {
                    enteredDate: data.enteredDate,
                    amount: addExchangeAmount(data.fromInvestmentOption),
                    tradeDate: data.tradeDate,
                    transactionId: data.transactionId,
                    tabType: 'Exchange',
                    exchangeType: 'from',
                    fromInvestmentOption: data.fromInvestmentOption,
                    recurring: data.recurring,
                    tiffType: data.tiff && isIfTiff(data.fromInvestmentOption) ? 'from' : null,
                    isLcpIncluded: isIfLcp(data.toInvestmentOption || []) || isIfLcp(data.fromInvestmentOption)
                };
            }
            if (data.toInvestmentOption) {
                toExchangesData = {
                    enteredDate: data.enteredDate,
                    amount: addExchangeAmount(data.toInvestmentOption),
                    tradeDate: data.tradeDate,
                    transactionId: data.transactionId,
                    tabType: 'Exchange',
                    exchangeType: 'to',
                    toInvestmentOption: data.toInvestmentOption,
                    recurring: data.recurring,
                    tiffType: data.tiff && isIfTiff(data.toInvestmentOption) ? 'into' : null,
                    isLcpIncluded: isIfLcp(data.toInvestmentOption) || isIfLcp(data.fromInvestmentOption || [])
                };
            }
            allTransactionData.push(fromExchangesData);
            allTransactionData.push(toExchangesData);
        })
        data.otherTransactions.map((data) => {
            let newData = { ...data, ...{ tabType: 'Other Transaction' } };
            allTransactionData.push(newData);
        })
        return allTransactionData;
    }

    const getSortedData = (data, type, sDate, eDate) => {
        let sortedData = {
            'contributions': [],
            'exchanges': [],
            'grants': [],
            'otherTransactions': [],
        }
        if (data.contributions) {
            sortedData.contributions = filterData(data.contributions, 'contributions', type, sDate, eDate);
        }
        if (data.exchanges) {
            sortedData.exchanges = filterData(data.exchanges, 'exchanges', type, sDate, eDate);
        }
        if (data.grants) {
            sortedData.grants = filterData(data.grants, 'grants', type, sDate, eDate);
        }
        if (data.otherTransactions) {
            sortedData.otherTransactions = filterData(data.otherTransactions, 'otherTransactions', type, sDate, eDate);
        }
        return sortedData;
    }

    if (data.selectedVal) {
        if (data.selectedVal.indexOf('All') === -1 && !isCustomDates && data.selectedVal.length > 0) {
            data.selectedVal.map((yDate) => {
                let sDate = '1/1/' + yDate;
                sDate = moment(moment(sDate).format('MM/DD/YYYY')).format('x');

                let eDate = moment().format('x');
                if (moment(todayDate(), "MM/DD/YYYY") >= moment('12/31/' + yDate, "MM/DD/YYYY")) {
                    eDate = '12/31/' + yDate
                    eDate = moment(moment(eDate).format('MM/DD/YYYY')).format('x');
                }
                if (data.tabName && data.tabName.tabType === 'AllTransactions') {
                    if (eDate && sDate && data.transactionalDetails.data && data.transactionalDetails.data.allData) {
                        let sortedAllData;
                        let allTransactionData;
                        if (data.isTradeDate) {
                            sortedAllData = getSortedData(data.transactionalDetails.data.allData, 'tradeDate', sDate, eDate);
                        } else {
                            sortedAllData = getSortedData(data.transactionalDetails.data.allData, 'enteredDate', sDate, eDate);
                        }
                        allTransactionData = getAllTransactionData(sortedAllData);
                        sortedTransactionalDetails.allTransactionData.push(...allTransactionData);
                    }
                } else {
                    if (eDate && sDate && data.transactionalDetails.data) {
                        let sortedTabsData;
                        if (data.isTradeDate) {
                            sortedTabsData = getSortedData(data.transactionalDetails.data, 'tradeDate', sDate, eDate);
                        } else {
                            sortedTabsData = getSortedData(data.transactionalDetails.data, 'enteredDate', sDate, eDate);
                        }
                        sortedTransactionalDetails.contributions = sortedTabsData.contributions;
                        sortedTransactionalDetails.exchanges = sortedTabsData.exchanges;
                        sortedTransactionalDetails.grants = sortedTabsData.grants;
                        sortedTransactionalDetails.otherTransactions = sortedTabsData.otherTransactions;
                    }
                }

                if (endDate && startDate && data.balanceDetails) {
                    let balanceData = {};
                    for (var key in data.balanceDetails) {
                        if (data.balanceDetails.hasOwnProperty(key)) {
                            if (endDate > data.balanceDetails[key].from.date && data.balanceDetails[key].from.date > startDate) {
                                balanceData[key] = data.balanceDetails[key]
                            }
                        }
                    }

                    sortedTransactionalDetails.sortedBalanceDetails = balanceData;
                }
            })

        } else {
            if (data.transactionalDetails.data) {
                sortedTransactionalDetails.contributions = data.transactionalDetails.data.contributions;
                sortedTransactionalDetails.exchanges = data.transactionalDetails.data.exchanges;
                sortedTransactionalDetails.grants = data.transactionalDetails.data.grants;
                sortedTransactionalDetails.otherTransactions = data.transactionalDetails.data.otherTransactions;
                sortedTransactionalDetails.sortedBalanceDetails = data.balanceDetails;
            } else {
                sortedTransactionalDetails.contributions = [];
                sortedTransactionalDetails.exchanges = [];
                sortedTransactionalDetails.grants = [];
                sortedTransactionalDetails.otherTransactions = [];
            }
            if (data.transactionalDetails.data && data.transactionalDetails.data.allData) {
                let allTransactionData;
                allTransactionData = getAllTransactionData(data.transactionalDetails.data.allData);
                sortedTransactionalDetails.allTransactionData.push(...allTransactionData);
            }
        }
    }

    return sortedTransactionalDetails;
}